var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconAmex = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  className: "icon icon--amex",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.53 10.339l-1.009 1.091-.978-1.091h-3.197v3.329h3.147l1.016-1.103.978 1.103h1.022l-1.486-1.655 1.486-1.674h-.979zm-2.439 2.639h-1.956v-.665h1.743v-.677h-1.743v-.608h1.994L17 12l-.909.978zm-8.715-2.752l-.01-.02h.01v.02zm2.997 2.37l-1.041-2.257H8.034v3.147l-1.348-3.147H5.502l-1.423 3.329h.865l.307-.746h1.655l.307.746h1.618V11.06l1.154 2.608h.702l1.147-2.608.006 2.608h.784v-3.329h-1.292l-.959 2.257zm-4.84-.364l.545-1.329.545 1.329h-1.09zM22 4H2a2 2 0 00-2 2v12a2 2 0 002 2h20a2 2 0 002-2V6a2 2 0 00-2-2zm-1 10.32h-2.859l-.633-.721-.677.721H6.724l-.301-.74h-.69l-.301.74H3l2.031-4.64h4.771l.533 1.198.52-1.198h6.056l.614.708.658-.708H21l-2.038 2.332L21 14.32z"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconAmex, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconAmex.acdacf11.svg";
export { ForwardRef as ReactComponent };